<template>
  <wrapper-page>
    <template v-slot:MainContentHeaderActions>
      <div
        v-if="$auth.user.isAgent"
        class="col-md-8 col-sm-12 text-right hidden-xs"
      >
        <button
          v-if="isProjectCompleted && !project.archived"
          @click="isProjectArchiveOrUnarchiveClick = true"
          class="btn btn-warning mr-2"
          :disabled="!canArchiveProjects || isSubscriptionReadOnly()"
          :title="
            !canArchiveProjects &&
            'You reached the archived projects limit for your workspace.'
          "
        >
          Archive Project
        </button>
        <router-link
          :to="{ path: `/projects/${projectId}/timelines` }"
          class="btn btn-primary ml-2"
        >
          Timelines
        </router-link>
        <router-link
          :to="{ path: `/projects/${projectId}` }"
          class="btn btn-primary ml-2"
          ><i class="icon-equalizer"></i>
          <span>Project Settings</span></router-link
        >
        <router-link
          v-if="project?.client_id"
          :to="{ path: `/clients/${project.client_id}` }"
          class="btn btn-primary ml-2"
          ><i class="icon-settings"></i>
          <span>Client Settings</span></router-link
        >
      </div>
    </template>

    <div class="d-flex align-items-center" style="padding-bottom: 1.5rem">
      <h1
        class="d-inline-block mr-2"
        style="margin-bottom: 0; line-height: 1.7rem"
      >
        {{ project.name }}
      </h1>
      <span
        v-if="project.archived"
        :class="[
          'badge',
          'xs',
          project.cancelled ? 'badge-disabled' : 'badge-primary',
        ]"
        >{{ project.cancelled ? "cancelled" : "Archived" }}</span
      >
    </div>

    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="body">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#previewSharing"
                  :class="activeTab == 'previewSharing' ? `active` : ``"
                  @click="activeTab = 'previewSharing'"
                  >Preview sharing</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#deliverables"
                  :class="activeTab == 'deliverables' ? `active` : ``"
                  @click="activeTab = 'deliverables'"
                  >Deliverables</a
                >
              </li>
              <li class="nav-item" v-if="showFeedbackTab">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#feedback"
                  :class="activeTab == 'feedback' ? `active` : ``"
                  @click="activeTab = 'feedback'"
                >
                  Feedback
                </a>
              </li>
            </ul>
            <div class="tab-content mt-0">
              <div
                class="tab-pane"
                id="previewSharing"
                :class="activeTab == 'previewSharing' ? `active` : ``"
              >
                <div class="body">
                  <div style="min-height: 400px">
                    <button
                      @click="addNewDeliverable"
                      type="button"
                      class="btn btn-primary mr-2 custom-plus-button"
                      title="Add New Deliverable"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                    <span><b>Add deliverable</b></span>
                    <div class="mt-4 row clearfix">
                      <table
                        class="col-12 col-lg-10 custom-table"
                        style="min-height: 100px; max-width: 1215px"
                      >
                        <thead>
                          <tr>
                            <th></th>
                            <th class="text-left" style="width: 15rem">
                              Deliverable Name
                            </th>
                            <th class="text-left" style="width: 15rem">
                              Stage
                            </th>
                            <th class="text-left" style="width: 8rem">
                              Move forward
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-for="(
                              multiDeliverable, index
                            ) in multiDeliverables"
                          >
                            <tr :data-id="index" :key="index">
                              <td style="width: 50px">
                                <button
                                  v-if="multiDeliverables?.length > 1"
                                  @click="removeDeliverable(index)"
                                  type="button"
                                  class="btn btn-danger btn-sm"
                                  title="Remove Stage"
                                  style="
                                    margin-right: auto;
                                    margin-bottom: 1rem;
                                  "
                                >
                                  <span class="sr-only">Remove stage</span>
                                  <i class="fa fa-times"></i>
                                </button>
                              </td>
                              <td>
                                <form-input-group
                                  :key="`${multiDeliverable.workflowId}-${multiDeliverable.stageId}-workflow-options`"
                                  :field="{
                                    type: 'select',
                                    name: `workflow ${index}`,
                                    options: [
                                      { value: 0, text: 'Select Workflow' },
                                      ...workflowOptions,
                                    ],
                                  }"
                                  :value="
                                    multiDeliverables[index].workflowId ?? 0
                                  "
                                  @input="(wId) => onWorkflowSelect(wId, index)"
                                />
                              </td>
                              <td>
                                <form-input-group
                                  :key="`${multiDeliverable.workflowId}-${multiDeliverable.stageId}-stage-options`"
                                  v-if="
                                    stageOptions(
                                      multiDeliverable?.workflowId,
                                      index
                                    )?.length
                                  "
                                  :field="{
                                    type: 'select',
                                    name: `stage ${index}`,
                                    options: [
                                      { value: 0, text: 'Select Stage' },
                                      ...stageOptions(
                                        multiDeliverable?.workflowId,
                                        index
                                      ),
                                    ],
                                  }"
                                  :value="multiDeliverables[index].stageId ?? 0"
                                  @input="(sId) => onStageSelect(sId, index)"
                                />
                              </td>
                              <td>
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    checked=""
                                    v-model="multiDeliverable.moveForward"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                              <td>
                                <div
                                  v-if="multiDeliverable?.revisionId"
                                  class="d-flex flex-wrap align-items-center gap-x-2"
                                >
                                  <div
                                    class="flex-none type-switch-group btn-group btn-group-sm mb-3"
                                  >
                                    <button
                                      type="button"
                                      class="btn"
                                      :class="
                                        multiDeliverable.type === 'files'
                                          ? 'btn-primary'
                                          : 'btn-default'
                                      "
                                      :style="
                                        multiDeliverable.type === 'files' &&
                                        'background-color: #0069d9; border-color: #0062cc'
                                      "
                                      @click="setType(index, 'files')"
                                    >
                                      Upload
                                    </button>
                                    <!-- `style` had to be used for the button's color because the bootstrap `btn-primary` class was overwritten in some components to be like the colors of `btn-info` -->
                                    <button
                                      type="button"
                                      class="btn"
                                      :class="
                                        multiDeliverable.type === 'link'
                                          ? 'btn-primary'
                                          : 'btn-default'
                                      "
                                      :style="
                                        multiDeliverable.type === 'link' &&
                                        'background-color: #0069d9; border-color: #0062cc'
                                      "
                                      @click="setType(index, 'link')"
                                    >
                                      Link
                                    </button>
                                  </div>

                                  <div
                                    v-if="multiDeliverable.type === 'link'"
                                    class="flex-1 form-group"
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="Review link"
                                      v-model="multiDeliverable.reviewLink"
                                      style="min-width: 153px"
                                    />
                                  </div>
                                  <div
                                    v-else-if="
                                      multiDeliverable.type === 'files'
                                    "
                                    class="form-group w-100"
                                    style="min-width: 200px"
                                  >
                                    <FileDrop
                                      :files="
                                        files[multiDeliverable?.revisionId]
                                      "
                                      :field="{
                                        name: `revision-${multiDeliverable?.revisionId}-files`,
                                        multiple: true,
                                      }"
                                      @added="
                                        (newFiles) =>
                                          addedFiles(
                                            multiDeliverable.workflowId,
                                            multiDeliverable.revisionId,
                                            newFiles
                                          )
                                      "
                                      @remove="
                                        (i) =>
                                          removeFile(
                                            multiDeliverable.workflowId,
                                            multiDeliverable.revisionId,
                                            i
                                          )
                                      "
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                      <div
                        class="col-12 col-lg-10 mt-1"
                        style="max-width: 1240px"
                      >
                        <div
                          class="col-12 mb-2"
                          style="
                            display: flex;
                            flex-direction: row;
                            gap: 1rem;
                            flex-wrap: wrap;
                            align-items: baseline;
                            justify-content: space-between;
                          "
                        >
                          <p class="mb-0">
                            Time allowed for client feedback:
                            <strong
                              >{{
                                project?.days_allowed_for_client_feedback
                              }}
                              business days</strong
                            >
                          </p>
                          <div v-if="emailTemplates?.length">
                            <label class="mt-2 mr-1" for="ddlTemplates"
                              >Templates</label
                            >
                            <button
                              id="ddlTemplates"
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {{ emailTemplate?.title }}
                            </button>
                            <div
                              v-if="emailTemplates.length"
                              class="dropdown-menu"
                            >
                              <a
                                v-for="(template, index) in emailTemplates"
                                :key="template?.title"
                                class="dropdown-item"
                                @click="chosenTemplateIndex = index"
                                >{{ template?.title }}</a
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <email-template-editor
                            v-model="emailText"
                            :placeholder="placeholder"
                            :templateType="emailTemplate?.type"
                            ref="summernoteTextEditor"
                            rows="10"
                          />
                          <div
                            class="align-right d-flex justify-content-end mt-3"
                          >
                            <button
                              type="button"
                              class="btn btn-info"
                              @click="preview"
                              :disabled="isSendingUpdate"
                            >
                              Preview &amp; Send
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane"
                id="deliverables"
                :class="activeTab == 'deliverables' ? `active` : ``"
              >
                <ProjectDeliverables
                  v-if="project"
                  :deliverables="deliverables"
                  :originalDeliverablesString="null"
                  :project="project"
                  ref="project-deliverables"
                  readonly
                  is-brief
                />
              </div>
              <div
                v-show="activeTab === 'feedback'"
                class="tab-content"
                id="feedback"
              >
                <div class="col-md-12 col-sm-12 col-lg-9 pt-2 pl-4">
                  <feedback-tab
                    :project="project"
                    :surveysFeedback="surveysFeedback"
                    :surveysStatus="surveysStatus"
                  ></feedback-tab>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ActionConfirmModal
      v-if="isProjectArchiveOrUnarchiveClick"
      :title="projectArchiveModalProps.title"
      :text="projectArchiveModalProps.text"
      :submitText="projectArchiveModalProps.submitText"
      @close="isProjectArchiveOrUnarchiveClick = false"
      @submit="
        () => {
          archiveProject(true);
          isProjectArchiveOrUnarchiveClick = false;
        }
      "
    />
    <PendingMultiUpdateEmailTemplateSetupModal
      v-if="hasNoMultiUpdateEmailTemplates"
    />
  </wrapper-page>
</template>

<script>
import WrapperPage from "../components/layout/WrapperPage.vue";
import ActionConfirmModal from "../components/ui/Modals/ActionConfirmModal.vue";
import {
  addRevisionFile,
  archiveProjectById,
  deleteRevisionFile,
  getDeliverableFiles,
  getProjectById,
  getProjectDeliverables,
  getProjectTimelineEvents,
  getRevisionFiles,
  sendMultiUpdateRevisionPreview,
} from "@/apis/projects";
import { getAllWorkflows, getWorkflowById } from "@/apis/workflows";
import workflowMixin from "../mixins/workflow";
import eventBus, { channels } from "@/eventBus";
import textEditorCompilerMixin from "@/mixins/textEditorCompiler";
import { getEmailTemplates } from "@/apis/email-templates";
import { getClientById } from "@/apis/clients";
import FormInputGroup from "@/components/ui/FormInputGroup.vue";
import ProjectMultiUpdatePreviewModal from "@/components/projects/ProjectMultiUpdatePreviewModal.vue";
import ProjectDeliverables from "@/components/projects/ProjectDeliverables.vue";
import FileDrop from "@/components/FileDrop.vue";
import {
  makeThumbnailFromImageFile,
  makeThumbnailFromVideoFile,
} from "@/utils/thumbnail";
import FeedbackTab from "@/components/ui/FeedbackSurvey/FeedbackTab.vue";
import { getAllSurveyWithFeedback, surveysStatus } from "@/apis/survey";
import PendingMultiUpdateEmailTemplateSetupModal from "@/components/ui/Modals/PendingMultiUpdateEmailTemplateSetupModal.vue";
import { THUMBNAIL_EXTENSIONS } from "@/utils/app.constant";
import EmailTemplateEditor from "@/components/ui/EmailTemplates/EmailTemplateEditor.vue";

export default {
  components: {
    PendingMultiUpdateEmailTemplateSetupModal,
    FeedbackTab,
    FileDrop,
    ProjectDeliverables,
    FormInputGroup,
    WrapperPage,
    ActionConfirmModal,
    EmailTemplateEditor,
  },
  mixins: [workflowMixin, textEditorCompilerMixin],
  data() {
    return {
      loadingTimeline: true,
      activeTab: "previewSharing",
      project: {},
      projectId: this.$route.params.projectId,
      selectedWorkflowID: this.$route.params.workflowId,
      timeline: {},
      events: [],
      filteredEvents: [],
      deliverables: [],
      originalDeliverablesString: null, // Used to keep track of changes to the deliverables list
      isProjectArchiveOrUnarchiveClick: false,
      projectArchiveModalProps: {
        submitText: "Ok",
        title: "Are you sure you want to archive this project?",
        text: "This project will be hidden and can be found in the archived projects section.",
      },
      workflows: [],
      workflowIds: [],
      selectedWorkflow: {},
      multiDeliverables: [
        {
          workflowId: null,
          workflowTitle: null,
          revisionId: null,
          stageId: null,
          stageTitle: null,
          moveForward: true,
          reviewLink: null,
          type: "link",
        },
      ],
      files: {},
      placeholder: "Write here..",
      emailText: "",
      chosenTemplateIndex: -1,
      allEmailTemplates: [],
      emailTemplates: [],
      client: {},
      isSendingUpdate: false,
      surveysFeedback: [],
      surveysStatus: [],
      hasNoMultiUpdateEmailTemplates: false,
    };
  },
  computed: {
    workflowOptions() {
      const workflows = (this.project.projectWorkflows ?? []).map((pwf) => ({
        ...this.workflows.find((w) => w.id === pwf.workflow_id),
        value: pwf.workflow_id,
        text: pwf.workflow_title,
        stages:
          this.getCurrentStages(
            this.workflows.find((wf) => wf.id === pwf.workflow_id)
          )
            ?.filter(
              (s) =>
                s.tasks.filter(
                  (t) => t.type === "Revision" && t.status === "in_progress"
                )?.length
            )
            ?.map((st) => ({
              ...st,
              value: st.id,
              text: st.title,
            })) ?? [],
      }));

      return workflows.filter((w) => w); // TODO
    },
    // gets the chosen email template in the client's language (falls back to the default language)
    emailTemplateInClientLanguage() {
      const clientLanguage = this.client?.language ?? "en";
      const chosenEmailTemplateId = this.emailTemplate?.id ?? -1;

      if (chosenEmailTemplateId === -1) return null;

      const templateVariants = this.allEmailTemplates.filter(
        (t) =>
          t.id === chosenEmailTemplateId ||
          t.parent_id === chosenEmailTemplateId
      );

      let template = templateVariants.find(
        (t) => t.language === clientLanguage
      );

      if (!template)
        // template in client language was not found, fall back on default language
        template = templateVariants.find((t) => t.language === "en");

      if (!template)
        // default to the parent template
        return this.emailTemplate;

      return template;
    },
    emailTemplate() {
      return this.emailTemplates[this.chosenTemplateIndex ?? 0] ?? null;
    },
    canArchiveProjects() {
      return this.$store.getters.archivedProjectsRemaining !== 0;
    },
    isProjectCompleted() {
      return (
        this.getProductionProgress(
          this.timeline,
          this.project.is_survey_sent,
          this.project.send_csat_survey,
          this.project.survey_completed
        ) === 100
      );
    },
    showFeedbackTab() {
      if (this.$auth.user.isAgent) return true;

      return this.project?.is_survey_sent;
    },
  },
  async created() {
    if (isNaN(Number(this.projectId))) {
      this.$router.push("/projects/");
      return;
    }

    if (this.$auth.user.isAgent) this.loadData();
  },
  methods: {
    preview() {
      const modalOptions = {
        name: "project-multi-update-preview-modal",
        height: "auto",
      };

      this.$modal.show(
        ProjectMultiUpdatePreviewModal,
        {
          multiDeliverables: this.multiDeliverables.filter(
            (md) => md.workflowId && md.stageId
          ),
          template: this.emailText,
          language: this.emailTemplate?.language,
          project: this.project,
        },
        modalOptions,
        {
          "before-close": async (e) => {
            const toSend = e.params?.value?.action === "send";
            if (!toSend || this.isSendingUpdate) return;

            const urlRegex = /^(http|https|ftp):\/\/.*$/;
            if (
              this.multiDeliverables.some((md) => {
                return (
                  md.reviewLink?.length &&
                  md.reviewLink !== "[files]" &&
                  !md.reviewLink.match(urlRegex)
                );
              })
            ) {
              this.notifyError("Review link must include http");
              return;
            }

            this.isSendingUpdate = true;

            const processedDeliverables = this.multiDeliverables
              .filter((md) => md.workflowId && md.stageId)
              .map((md) => {
                const workflow = this.workflows.find(
                  (w) => w.id === md.workflowId
                );
                const stage = this.getStageByIdFromWorkflow(
                  workflow,
                  md.stageId
                );

                const currentRevision = this.getCurrentStageRevision(stage);

                if (!currentRevision?.id) return;

                return {
                  workflowId: md.workflowId,
                  revisionId: currentRevision.id,
                  reviewLink: md.type === "files" ? "[files]" : md.reviewLink,
                  updateStatus: md.moveForward,
                };
              });

            sendMultiUpdateRevisionPreview(
              this.projectId,
              this.emailText,
              processedDeliverables
            )
              .then(() => {
                this.notifySuccess("Deliverable updates sent");
                this.isSendingUpdate = false;
                this.$router.push({
                  name: "project-timelines",
                  params: { projectId: this.projectId },
                });
              })
              .catch((error) => {
                this.notifyError(error, "Error updating deliverables");
                this.isSendingUpdate = false;
              });
          },
        }
      );
    },
    stageOptions(workflowId, multiDeliverableIndex) {
      if (!workflowId) return [];

      const stages =
        this.workflowOptions.find((wo) => wo.value === workflowId)?.stages ??
        [];
      if (multiDeliverableIndex)
        return stages.filter((stage) => {
          let used = false;

          for (let x = 0; x < this.multiDeliverables.length; x++) {
            if (x === multiDeliverableIndex) continue;

            const multiDeliverable = this.multiDeliverables[x];
            if (multiDeliverable.workflowId !== workflowId) continue;

            if (multiDeliverable.stageId === stage.id) used = true;
          }

          return !used;
        });

      return stages;
    },
    onWorkflowSelect(workflowId, index) {
      const w = this.workflowIds.find((wIds) => wIds.workflow_id == workflowId);
      if (!w) return;

      const current = this.multiDeliverables[index];
      this.$set(this.multiDeliverables, index, {
        ...current,
        workflowId: w.workflow_id,
        workflowTitle: w.workflow_title,
        stageId: null,
        stageTitle: null,
      });
    },
    async onStageSelect(stageId, index) {
      const current = this.multiDeliverables[index];
      const stage = this.stageOptions(current.workflowId).find(
        (o) => o.value == stageId
      );

      const currentRevision = this.getCurrentStageRevision(stage);
      let reviewLink = null;

      if (currentRevision?.id) {
        this.retrieveRevisionFiles(current.workflowId, currentRevision.id);

        // populate prev review link
        let review_link = currentRevision?.review_link; // Maybe current revision has one already
        if (review_link) {
          reviewLink = review_link;
        } else {
          // If not, fetch from previous one
          let prevRev = this.getPreviousRevision(currentRevision, stage);
          if (prevRev) {
            const prevRevLink = prevRev?.data?.review_link;
            const prevRevFiles = await getRevisionFiles(
              this.project.id,
              this.multiDeliverables[index].workflowId,
              prevRev.id
            ).then((res) => {
              return res;
            });

            if (prevRevFiles?.length) {
              reviewLink = null;
            } else if (prevRevLink) {
              reviewLink = prevRevLink;
            }
          }
        }
      }

      this.$set(this.multiDeliverables, index, {
        ...current,
        stageId: stageId,
        stageTitle: stage?.text,
        revisionId: currentRevision?.id,
        reviewLink,
      });
    },
    async addedFiles(workflowId, revisionId, files) {
      if (!files?.length) return;
      if (!this.files[revisionId]) this.$set(this.files, revisionId, []);

      // filter out disallowed file extensions
      files = files.filter((file) => {
        if (
          !file.type ||
          file.type.match("x-sh") ||
          file.type.match("x-msdownload")
        ) {
          alert(
            file.type
              ? `${file.name ?? "file"} type ${file.type} is not allowed`
              : `${file.name ?? "file"} has no type`
          );

          return false;
        }

        return true;
      });

      // filter out existing files
      files = files.filter((file, i) => {
        const existingFileIndex = this.files[revisionId].findIndex(
          (f) => f.name === file.name
        );
        if (existingFileIndex >= 0) {
          if (
            confirm(`${file.name} already exists. Do you want to overwrite?`)
          ) {
            files[i].toReplace = existingFileIndex;
            return true;
          }
          return false;
        }

        return true;
      });

      files.map(async (file) => {
        file.isUploading = true;
        let thumbnail;
        if (file.type.match("image")) {
          thumbnail = await makeThumbnailFromImageFile(file);
          file.thumbnail = URL.createObjectURL(thumbnail);
        } else if (
          file.type.match("video") &&
          file.type !== "video/quicktime"
        ) {
          thumbnail = await makeThumbnailFromVideoFile(file);
          file.thumbnail = URL.createObjectURL(thumbnail);
        }

        this.$nextTick(() => {
          addRevisionFile(
            this.project.id,
            workflowId,
            revisionId,
            file,
            false,
            (progress) => {
              const fileIndex = this.files[revisionId].findLastIndex(
                (f) => f.name === file.name
              );
              if (fileIndex === -1) return;

              const revisionFiles = [...this.files[revisionId]];
              revisionFiles[fileIndex].progress =
                progress.loadedBytes / file.size;

              this.files[revisionId] = revisionFiles;
            }
          )
            .then(() => {
              const fileIndex = this.files[revisionId].findLastIndex(
                (f) => f.name === file.name
              );
              if (fileIndex < 0) return;

              const revisionFiles = [...this.files[revisionId]];
              revisionFiles[fileIndex].isUploading = false;
              if (file.toReplace >= 0) revisionFiles.splice(file.toReplace, 1);

              this.files[revisionId] = revisionFiles;
            })
            .catch((error) => {
              this.notifyError(error, `Error uploading ${file.name ?? "file"}`);

              const fileIndex = this.files[revisionId].findIndex(
                (f) => f.name === file.name
              );
              if (fileIndex < 0) return;

              const revisionFiles = [...this.files[revisionId]];
              revisionFiles.splice(fileIndex, 1);

              this.files[revisionId] = revisionFiles;
            });

          if (thumbnail) {
            addRevisionFile(
              this.project.id,
              workflowId,
              revisionId,
              thumbnail,
              true
            );
          }
        });
      });

      this.files[revisionId] = [...this.files[revisionId], ...files];
    },
    removeFile(workflowId, revisionId, index) {
      const files = [...this.files[revisionId]];
      const filename = files[index]?.name;

      files.splice(index, 1);

      deleteRevisionFile(this.project.id, workflowId, revisionId, filename);

      this.files[revisionId] = files;
    },
    async retrieveRevisionFiles(workflowId, revisionId) {
      const files = await getRevisionFiles(
        this.project.id,
        workflowId,
        revisionId
      )
        .then(async (res) => {
          return (res ?? []).map((f) => {
            const storageEndpoint = process.env.VUE_APP_AZ_STORAGE_ENDPOINT;
            const url = `${storageEndpoint}${
              storageEndpoint.at(-1) !== "/" ? "/" : ""
            }documents/${f.path}`;
            const filename = url.substring(url.lastIndexOf("/") + 1);

            let thumbnail = null;
            const type = `.${filename.split(".")[1]?.toLowerCase()}`;
            if (THUMBNAIL_EXTENSIONS.includes(type)) {
              thumbnail = url.replace(filename, `thumbnails/${filename}`);
            }

            return {
              url,
              size: f.size,
              created_on: f.created_on,
              thumbnail,
              name: filename,
              type,
            };
          });
        })
        .catch((error) => {
          this.notifyError(error, "Error getting files for revision");
        });

      this.$set(this.files, revisionId, files);
    },
    addNewDeliverable() {
      this.multiDeliverables.push({
        workflowId: null,
        stageId: null,
        stageTitle: null,
        revisionId: null,
        moveForward: true,
        reviewLink: null,
        type: "link",
      });
    },
    removeDeliverable(index) {
      if (this.multiDeliverables?.length <= 1) return;

      this.multiDeliverables.splice(index, 1);
    },
    setType(index, newType) {
      this.$set(this.multiDeliverables[index], "type", newType);
    },
    onEditorChange(value) {
      this.emailText = this.replacePlaceholdersHelper(value);
    },
    updateChosenTemplateIndex() {
      // Filter and sort email templates
      this.allEmailTemplates = (this.$store.getters.emailTemplates || [])
        .filter((template) => template.type === "multi-update")
        .sort((a, b) => a.id - b.id);

      this.emailTemplates = this.allEmailTemplates.filter((t) => !t.parent_id);

      // Set email text based on chosen template
      if (
        this.chosenTemplateIndex !== -1 &&
        this.emailTemplateInClientLanguage
      ) {
        this.emailText = this.replacePlaceholdersHelper(
          this.emailTemplateInClientLanguage.body,
          this.emailTemplateInClientLanguage.language
        );
      }
    },
    replacePlaceholdersHelper(text) {
      return this.replacePlaceholders(
        text,
        this.root,
        this.client,
        this.model,
        this.project
      );
    },
    async getAndUpdateProjectData(projectId) {
      const projectData = await getProjectById(projectId, true);
      this.workflowIds = projectData.projectWorkflows;
      this.workflows = await getAllWorkflows(
        "id in (" +
          (projectData.projectWorkflows ?? [])
            .map((pw) => pw.workflow_id)
            .join() +
          ")"
      );
      this.events = await getProjectTimelineEvents(this.projectId);
      if (projectData.deliverable_type === "Multi") {
        this.filteredEvents = this.filterEventsByWorkflowId(
          this.events,
          this.selectedWorkflowID
            ? this.selectedWorkflowID
            : this.workflowIds?.[0]?.workflow_id
        );
      } else {
        this.filteredEvents = [...this.events];
      }
      const cancelProjectEvent = this.filteredEvents.find(
        (e) => e.category === "Cancel Project"
      );
      const sendPreviewEvents = this.filteredEvents.filter(
        (e) => e.category === "Send Preview"
      );
      const rejectEvent = this.filteredEvents.filter(
        (e) =>
          e.category === "Revision Rejected" || e.category === "Stage Rejected"
      );

      if (projectData && cancelProjectEvent) {
        projectData.cancelEventInfo = JSON.parse(cancelProjectEvent.event);
        projectData.cancelEventInfo.event_time = cancelProjectEvent.event_time;
      }
      if (projectData && sendPreviewEvents.length) {
        projectData.sendPreviewEvents = sendPreviewEvents.map(
          (previewEvent) => {
            const eventObj = JSON.parse(previewEvent.event);
            eventObj.event_time = previewEvent.event_time;
            eventObj.user_id = previewEvent.user_id;
            return eventObj;
          }
        );
      }
      if (projectData && rejectEvent.length) {
        projectData.rejectEvents = rejectEvent.map((rEvent) => {
          const eventObj = JSON.parse(rEvent.event);
          eventObj.event_time = rEvent.event_time;
          eventObj.user_id = rEvent.user_id;
          return eventObj;
        });
      }
      return projectData;
    },
    filterEventsByWorkflowId(events, targetWorkflowId) {
      if (!targetWorkflowId) return events;
      const filteredEvents = events.filter((event) => {
        const parsedEvent = JSON.parse(event.event);
        return parsedEvent.workflow_id === targetWorkflowId;
      });
      return filteredEvents;
    },
    async loadData() {
      try {
        this.loadingTimeline = true;
        this.project = await this.getAndUpdateProjectData(this.projectId);
        this.client = await getClientById(this.project.client_id);
        if (this.project.deliverable_type === "Multi") {
          if (!this.selectedWorkflowID) {
            this.selectedWorkflow = this.project.projectWorkflows[0];
          } else {
            this.selectedWorkflow = this.project.projectWorkflows.find(
              (workflowData) =>
                workflowData.workflow_id === this.selectedWorkflowID
            );
          }
          this.timeline = await getWorkflowById(
            this.selectedWorkflow?.workflow_id
          );
        } else {
          this.timeline = await getWorkflowById(this.project.workflow_id);
        }

        this.surveysFeedback = await getAllSurveyWithFeedback(this.projectId);
        this.surveysStatus = await surveysStatus();

        this.refreshAndLoadDeliverables();
      } catch (err) {
        this.notifyError(err, "Error on loading project data");
        if (this.project.id && !this.timeline.id) {
          this.$router.push("/projects/" + this.projectId);
        } else {
          this.$router.push("/projects/");
        }
        return;
      }

      try {
        // If the first stage doesn't have a started_on set, we set it as the project's start_date
        if (this.is_linear && !this.timeline.tasks[0].started_on) {
          this.timeline.tasks[0].started_on = this.project.start_date;
        }
      } catch (err) {
        this.notifyError(err, "Error on loading project deliverables");
      } finally {
        this.loadingTimeline = false;
      }
      if (window.location.hash === "#feedback") {
        this.activeTab = "feedback";
      }
    },
    async refreshAndLoadDeliverables() {
      const result = await getProjectDeliverables(this.projectId);
      if (result && result.length > 0) {
        this.deliverables = result
          .map((d) => {
            if (!d.files) d.files = [];

            return d;
          })
          .sort((a, b) => a?.last_save_time - b?.last_save_time);

        this.deliverables.forEach((deliverable, i) => {
          if (!this.projectId || !deliverable.id) return;

          getDeliverableFiles(this.projectId, deliverable.id)
            .then((res) => {
              const files = (res ?? []).map((f) => {
                const storageEndpoint = process.env.VUE_APP_AZ_STORAGE_ENDPOINT;
                const url = `${storageEndpoint}${
                  storageEndpoint.at(-1) !== "/" ? "/" : ""
                }documents/${f.path}`;
                const filename = url.substring(url.lastIndexOf("/") + 1);

                let thumbnail = null;
                const type = `.${filename.split(".")[1]?.toLowerCase()}`;
                if (THUMBNAIL_EXTENSIONS.includes(type)) {
                  thumbnail = url.replace(filename, `thumbnails/${filename}`);
                }

                return {
                  url,
                  size: f.size,
                  created_on: f.created_on,
                  thumbnail,
                  name: filename,
                  type,
                };
              });

              this.$set(this.deliverables, i, {
                ...deliverable,
                files,
                type: files.length ? "files" : "link",
              });
            })
            .catch((error) => {
              this.notifyError(error, "Error getting files for deliverable");
            });
        });
      } else if (this.$auth.user.isAgent) {
        this.deliverables = [];
      }
    },
    async archiveProject(shouldArchive) {
      try {
        await archiveProjectById(this.projectId, shouldArchive);
        this.notifySuccess("Project Archived");
        this.$router.push("/projects/");
      } catch (err) {
        this.notifyError(err, "Error on archiving project");
      }
    },
  },
  watch: {
    client: function () {
      if (!this.emailTemplateInClientLanguage) return;

      this.emailText = this.replacePlaceholdersHelper(
        this.emailTemplateInClientLanguage.body,
        this.emailTemplateInClientLanguage.language
      );
    },
    timeline() {
      this.project.workflow = this.timeline;
    },
    chosenTemplateIndex: function () {
      if (!this.emailTemplateInClientLanguage) return;

      this.emailText = this.replacePlaceholdersHelper(
        this.emailTemplateInClientLanguage.body,
        this.emailTemplateInClientLanguage.language
      );
    },
    emailText: function () {
      if (!this.emailTemplateInClientLanguage) return;

      this.emailText = this.replacePlaceholdersHelper(
        this.emailText,
        this.emailTemplateInClientLanguage.language
      );
    },
    "$store.getters.emailTemplates": {
      handler() {
        this.updateChosenTemplateIndex();
      },
      immediate: true, // Trigger handler immediately on component mount
    },
  },
  async mounted() {
    if (!this.$auth.user.isAgent)
      return this.$router.push({
        path: `/projects/${this.projectId}/timelines`,
      });

    let templates = await getEmailTemplates().then((data) => {
      return data.sort((a, b) => a.id - b.id);
    });

    templates = templates.filter(function (template) {
      return template.type === "multi-update";
    });
    this.emailTemplates = templates;

    if (!this.emailTemplates?.length) {
      this.hasNoMultiUpdateEmailTemplates = true;
    } else {
      const multiUpdateTemplateIndex = this.emailTemplates.findIndex(
        (t) => t.type === "multi-update"
      );

      if (multiUpdateTemplateIndex >= 0)
        this.chosenTemplateIndex = multiUpdateTemplateIndex;

      if (this.emailTemplates[this.chosenTemplateIndex]) {
        this.emailText = this.replacePlaceholdersHelper(
          this.emailTemplates[this.chosenTemplateIndex].body
        );
      }
    }

    eventBus.$on(channels.fetchProject, async () => {
      this.project = await this.getAndUpdateProjectData(this.projectId);
      this.client = await getClientById(this.project.client_id);
    });
    eventBus.$on(channels.refreshProject, async () => {
      this.loadData();
    });
    eventBus.$on(channels.fetchTimeline, async () => {
      this.timeline = await getWorkflowById(this.project.workflow_id);
    });
    eventBus.$on(channels.fetchAllSurveyWithFeedback, async () => {
      this.surveysFeedback = await getAllSurveyWithFeedback(this.projectId);
    });
    eventBus.$on(channels.fetchAllSurveyStatus, async () => {
      this.surveysStatus = await surveysStatus();
    });
  },
  beforeDestroy() {
    eventBus.$off(channels.fetchProject);
    eventBus.$off(channels.refreshProject);
    eventBus.$off(channels.fetchTimeline);
    eventBus.$off(channels.fetchAllSurveyWithFeedback);
    eventBus.$off(channels.fetchAllSurveyStatus);
  },
};
</script>

<style scoped>
.btn-primary {
  background-color: #16a1b8;
  border-color: #16a1b8;
}

.custom-plus-button {
  padding: 0rem 0.3rem;
  height: 1.2rem;
  font-size: 0.8rem;
  margin: 0 0.5rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100% !important;
}

.custom-table th,
.custom-table td {
  padding: 0.5rem;
  text-align: center;
}

.type-switch-group button {
  padding: 6px 18px;
}

.type-switch-group button:first-child {
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}

.type-switch-group button:last-child {
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
}
</style>
